export const NotificationsText = {
    Notifications: {
        en: "Notifications",
        mr: "रेकॉर्ड केलेले व्हिडिओ",
    },
    ViewAll: {
        en: "View all",
        mr: "सर्व पहा",
    },
};
